import { render } from "./TenantConfigurationExport.vue?vue&type=template&id=3a9cca04&scoped=true"
import script from "./TenantConfigurationExport.vue?vue&type=script&lang=js"
export * from "./TenantConfigurationExport.vue?vue&type=script&lang=js"

import "./TenantConfigurationExport.vue?vue&type=style&index=0&id=3a9cca04&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9cca04"]])

export default __exports__